import { api } from "@/lib/apiClient";

const VAPID_PUBLIC = process.env.REACT_APP_VAPID_PUBLIC_KEY;

function urlBase64ToUint8Array(value) {
  const padding = "=".repeat((4 - (value.length % 4)) % 4);
  const base64 = (value + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return Uint8Array.from([...raw].map((c) => c.charCodeAt(0)));
}

export function pushSupported() {
  return "serviceWorker" in navigator && "PushManager" in window && "Notification" in window;
}

// Must be called from a user gesture (button click)
export async function enablePush() {
  if (!pushSupported()) throw new Error("This browser does not support notifications");
  if (!VAPID_PUBLIC) throw new Error("Push is not configured");
  if (Notification.permission === "denied") throw new Error("Notifications are blocked in your browser settings");
  const permission = await Notification.requestPermission();
  if (permission !== "granted") return false;
  const registration = await navigator.serviceWorker.register("/sw.js", { scope: "/" });
  await navigator.serviceWorker.ready;
  let sub = await registration.pushManager.getSubscription();
  if (!sub) {
    sub = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC),
    });
  }
  await api.post("/push/subscribe", sub.toJSON());
  return true;
}
